import PropTypes from 'prop-types';

export const smsConfirmation = PropTypes.shape({
    objectId: PropTypes.string.isRequired,
    objectType: PropTypes.string.isRequired,
    code: PropTypes.string,
    payId: PropTypes.number,
});

export const currencyPropType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    code: PropTypes.string,
    name: PropTypes.string.isRequired,
});

export const fieldPropType = (type = ['text']) =>
    PropTypes.shape({
        name: PropTypes.string,
        canonicalPath: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.arrayOf(PropTypes.string)]),
        checkRegexp: PropTypes.string,
        mandatory: PropTypes.bool,
        isError: PropTypes.bool,
        isReadOnly: PropTypes.bool,
        visible: PropTypes.bool,
        placeholder: PropTypes.string,
        type: PropTypes.oneOf(type),
    });

export const inputPropType = (type = ['text']) => {
    return {
        field: fieldPropType(type).isRequired,
        formName: PropTypes.string.isRequired,
        cssTitleClass: PropTypes.string,
        onBlurHandler: PropTypes.func,
    };
};

export const accountPropType = PropTypes.shape({
    cardAlias: PropTypes.string,
    bankName: PropTypes.string,
    account: fieldPropType(['text']),
    bik: fieldPropType(['bik']),
});

export const paymentInfoPropType = PropTypes.shape({
    account: PropTypes.object,
    accountTo: PropTypes.object,
    canTransferToBankAccount: PropTypes.bool.isRequired,
    canTransferToCard: PropTypes.bool.isRequired,
    fieldsFrom: PropTypes.object,
    fieldsTo: PropTypes.object,
    sourceFrom: PropTypes.string,
    sourceTo: PropTypes.string,
    sources: PropTypes.object,
});

export const sourcePropType = PropTypes.shape({
    alias: PropTypes.string,
    canUseForRequest: PropTypes.bool,
    cardExpired: PropTypes.string,
    cardLogo: PropTypes.string,
    code: PropTypes.string.isRequired,
    description: PropTypes.string,
    extras: PropTypes.shape({
        card_ps: PropTypes.string,
        exp_date: PropTypes.string,
    }),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    linked: PropTypes.bool,
    pan: PropTypes.string,
    paymentSystem: PropTypes.string,
    type: PropTypes.string,
});

export const paymentFormPropType = PropTypes.shape({
    addSourceInFromSection: PropTypes.bool,
    comment: PropTypes.string,
    currencyRateText: PropTypes.string,
    description: PropTypes.string,
    feeText: PropTypes.string.isRequired,
    feeTextInfo: PropTypes.string,
    fromAccountKey: PropTypes.string,
    fromAmount: PropTypes.object,
    fromPrvId: PropTypes.number.isRequired,
    paymentName: PropTypes.string,
    paymentSourceFromMethod: PropTypes.string.isRequired,
    deliveryMethod: PropTypes.string.isRequired,
    showUpgradeAccountBlock: PropTypes.bool,
    sourceCodeFrom: PropTypes.string,
    sourceCodeTo: PropTypes.string,
    sourceKey: PropTypes.string,
    toAccountKey: PropTypes.string,
    toAmount: PropTypes.object,
    toPrvId: PropTypes.number.isRequired,
    toValues: PropTypes.object,
    usePromoCode: PropTypes.bool,
});

export const countryPropType = PropTypes.shape({
    anonymousBalId: PropTypes.string,
    canBeTo: PropTypes.bool,
    canPayPrv: PropTypes.bool,
    code: PropTypes.string,
    currencies: PropTypes.arrayOf(currencyPropType),
    favorite: PropTypes.bool,
    id: PropTypes.number,
    name: PropTypes.string,
    onlyVisa: PropTypes.bool,
    paySystems: PropTypes.arrayOf(PropTypes.string).isRequired,
    paySystemsCode: PropTypes.arrayOf(PropTypes.string),
    paySystemNames: PropTypes.arrayOf(PropTypes.string),
    seoNameFrom: PropTypes.string,
    seoNameTo: PropTypes.string,
    showCountryFlag: PropTypes.bool,
    showDisclaimer: PropTypes.bool,
    showWaitingListDisclaimer: PropTypes.bool,
    toIcon: PropTypes.arrayOf(PropTypes.string),
    usageCount: PropTypes.number,
});

export const countryMenuPropType = PropTypes.shape({
    countryFrom: countryPropType.isRequired,
    countryTo: countryPropType.isRequired,
});

export const articlePropType = PropTypes.shape({
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
});
